module.exports = __webpack_public_path__ + "static/media/Gemma2.9d381d78.png";